import { FC } from 'react';
import { useCopilot } from '@/features/copilot';
import { CopilotChat } from './CopilotChat';
import { CopilotChatListView } from './CopilotChatListView';

export const CopilotPanel: FC = () => {
  const { view } = useCopilot();

  if (view === 'list') {
    return <CopilotChatListView />;
  }

  return <CopilotChat />;
};
